import React from "react";
import LegalDocument from "@/components/LegalDocument";

export default function CookiePolicy() {
  return (
    <LegalDocument
      titleKey="cookiesTitle"
      docKey="cookies"
      testId="legal-cookies-page"
    />
  );
}
